const BUSINESS_TYPES = [
  {
    label: "Commerciante Agricolo / Negozio Agricolo",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Rifugio per Animali / Ente Benefico",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Lotto di Ingrasso",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Produttore di Carne Bovina",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Polli da Carne", value: "Broilers", id: "broilers" },
  {
    label: "Gruppo d'Acquisto",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Produzione di Vitelli",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Allevamento/Sviluppatore di Vitelli",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  {
    label: "Acquirente di Bestiame",
    value: "Cattle Buyer",
    id: "cattle_buyer",
  },
  {
    label: "Allevatore a Contratto",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperativa", value: "Cooperative", id: "cooperative" },
  {
    label: "Sede Centrale",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Allevamento Vacche/Vitelli",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Produzione Lattiero-Casearia",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributore / Agente",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Mangimificio", value: "Feed Mill", id: "feed_mill" },
  { label: "Allevamento da Ingrasso", value: "Feedyard", id: "feedyard" },
  {
    label: "Allevatore/Ingrassatore",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Incubatoio", value: "Hatchery", id: "hatchery" },
  {
    label: "Produzione di Manze",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Integrazione di Galline Ovaiole",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Galline Ovaiole", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Cooperativa/Acquirente di Latte",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Produttore Misto/Altro",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Fornitore di Nutrienti",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Confezionatore/Trasformatore",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Punto Vendita al Dettaglio per Animali Domestici",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Farmacia", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Allevatore di Pollame",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Integratore di Pollame",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  {
    label: "Allevatore di Pecore",
    value: "Sheep Producer",
    id: "sheep_producer",
  },
  {
    label: "Operazione di Ingrasso",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Mercato del Bestiame/Asta",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  {
    label: "Allevatore di Suini",
    value: "Swine Producer",
    id: "swine_producer",
  },
  { label: "Tacchini", value: "Turkeys", id: "turkeys" },
  {
    label: "Università / Istruzione",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Studio Veterinario",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Grossista / Dettagliante",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Acquirente di Lana", value: "Wool Buyer", id: "wool_buyer" },
];
const FIELDS = {
  common: {
    errors: {
      required: "Richiesto",
    },
  },
  salutation: {
    label: "Saluto",
    placeholder: "Seleziona Saluto",
    errors: {
      required: "Il saluto è obbligatorio",
      invalid: "Seleziona un saluto valido",
    },
  },
  firstName: {
    label: "Nome",
    placeholder: "Giovanni",
    errors: {
      authenticatedNameUpdateTrial:
        "Hai effettuato l’accesso e il tuo nome non può essere modificato.",
      required: "Il nome è obbligatorio",
      minLength: "Il nome deve contenere almeno 2 caratteri",
      maxLength: "Il nome deve contenere al massimo 50 caratteri",
    },
  },
  lastName: {
    label: "Cognome",
    placeholder: "Rossi",
    errors: {
      authenticatedNameUpdateTrial:
        "Hai effettuato l’accesso e il tuo nome non può essere modificato.",
      required: "Il cognome è obbligatorio",
      minLength: "Il cognome deve contenere almeno 2 caratteri",
      maxLength: "Il cognome deve contenere al massimo 50 caratteri",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "giovanni.rossi@example.org",
    description:
      "Inserisci un indirizzo email personale, non un indirizzo email condiviso.",
    prefixWarningTitle: "Casella di posta condivisa rilevata",
    prefixWarningDescription:
      "Consigliamo di utilizzare un indirizzo email personale per un'esperienza personalizzata superiore",
    errors: {
      authenticatedEmailUpdateTrial:
        "Hai effettuato l’accesso e il tuo indirizzo e-mail non può essere modificato.",
      required: "L'email è obbligatoria",
      invalidEmail: "Inserisci un indirizzo email valido",
      emailAssociatedWithYourAccount:
        "Il tuo indirizzo email è associato al tuo account e non può essere modificato.",
    },
  },
  confirmEmail: {
    label: "Conferma Email",
    placeholder: "giovanni.rossi@example.org",
    errors: {
      authenticatedEmailUpdateTrial:
        "Hai effettuato l’accesso e il tuo indirizzo e-mail non può essere modificato.",
      required: "La conferma dell'email è obbligatoria",
      invalidEmail: "Inserisci un indirizzo email valido",
      emailMatchError: "Gli indirizzi email non corrispondono",
    },
  },
  password: {
    label: "Password",
    placeholder: "Inserisci la tua password",
    errors: {
      required: "La password è obbligatoria",
    },
  },
  confirmPassword: {
    label: "Conferma Password",
    placeholder: "Conferma la tua password",
    errors: {
      required: "La conferma della password è obbligatoria",
      passwordMatchError: "Le password non corrispondono",
    },
  },
  addressLine1: {
    label: "Indirizzo Linea 1",
    placeholder: "Via Roma 123",
    errors: {
      required: "L'indirizzo Linea 1 è obbligatorio",
      minLength: "L'indirizzo Linea 1 deve contenere almeno 5 caratteri",
      maxLength: "L'indirizzo Linea 1 deve contenere al massimo 100 caratteri",
    },
  },
  addressLine2: {
    label: "Indirizzo Linea 2",
    placeholder: "Appartamento 4B",
    errors: {
      required: "L'indirizzo Linea 2 è obbligatorio",
      maxLength: "L'indirizzo Linea 2 deve contenere al massimo 100 caratteri",
    },
  },
  city: {
    label: "Città / Paese",
    placeholder: "Milano",
    errors: {
      required: "La città / il paese è obbligatorio",
      minLength: "La città / il paese deve contenere almeno 2 caratteri",
      maxLength: "La città / il paese deve contenere al massimo 50 caratteri",
    },
  },
  country: {
    label: "Paese",
    placeholder: "Seleziona paese",
    errors: {
      required: "Il paese è obbligatorio",
      invalid: "Seleziona un paese valido",
    },
  },
  state: {
    label: "Provincia",
    placeholder: "Seleziona Provincia",
    errors: {
      required: "La provincia è obbligatoria",
      invalid: "Seleziona una provincia valida",
    },
  },
  jurisdiction: {
    label: "Giurisdizione della Licenza",
    placeholder: "Seleziona la giurisdizione della licenza",
    errors: {
      required: "La giurisdizione della licenza è obbligatoria",
      invalid: "Seleziona una giurisdizione valida",
    },
  },
  zipCode: {
    label: "CAP",
    placeholder: "12345",
    errors: {
      required: "Il CAP è obbligatorio",
      invalid: "Inserisci un CAP valido",
    },
  },
  role: {
    label: "Ruolo",
    placeholder: "Seleziona il tuo ruolo",
    errors: {
      required: "Seleziona il tuo ruolo",
      invalid: "Seleziona un ruolo valido",
    },
  },
  businessType: {
    label: "Tipo di Attività",
    placeholder: "Seleziona Tipo di Attività",
    errors: {
      required: "Il tipo di attività è obbligatorio",
      invalid: "Seleziona un tipo di attività valido",
    },
  },
  businessName: {
    label: "Nome Attività",
    placeholder: "Inserisci il nome dell'attività",
    errors: {
      required: "Il nome dell'attività è obbligatorio",
      minLength: "Il nome dell'attività deve contenere almeno 2 caratteri",
      maxLength:
        "Il nome dell'attività deve contenere al massimo 100 caratteri",
    },
  },
  businessSearch: {
    label: "Ricerca Attività:",
    addNewAccount: "Aggiungi Nuovo Account Aziendale",
    canNotFindBusiness: "Non trovi la tua attività?",
    guideline:
      "Inserisci il tuo CAP, quindi seleziona dall'elenco sottostante.",
    guidelineForNameSearch:
      "Inserisci il nome completo dell'attività, quindi seleziona dall'elenco.",
    placeholder: "Dove lavori?",
    noResults: "Nessun risultato trovato",
    searching: "Ricerca in corso...",
    selectedBusinessHeading: "Attività Selezionata:",
    selectedBusinessNotCorrect: "Non è corretto?",
    selectedBusinessTryAgain: "Riprova",
    selectedBusinessDismiss: "Ignora attività",
    resultsFound: {
      singular: "1 attività trovata",
      plural: "Più attività trovate",
    },
    errors: {
      network:
        "Stiamo riscontrando problemi di connessione al cercatore di attività. Riprova più tardi.",
    },
  },
  explicitConsent: {
    label:
      "Selezionando questa casella accetto di ricevere comunicazioni di marketing da Elanco.",
    errors: {
      required: "Il consenso è richiesto",
    },
  },
  explicitSmsConsent: {
    label:
      "Selezionando questa casella accetto di ricevere comunicazioni di marketing da Elanco tramite SMS/messaggio di testo.",
    errors: {
      required: "Il consenso agli SMS è obbligatorio",
    },
  },
  telephone: {
    label: "Telefono personale",
    placeholder: "Inserisci il tuo telefono personale",
    dialCodeLabel: "Prefisso",
    dialCodePlaceholder: "Cerca paese…",
    errors: {
      invalid: "Inserire un numero di telefono valido.",
    },
  },
  businessTelephone: {
    label: "Telefono aziendale",
    placeholder: "Inserisci il tuo telefono aziendale",
    dialCodeLabel: "Prefisso",
    dialCodePlaceholder: "Cerca paese…",
    errors: {
      invalid: "Inserire un numero di telefono valido.",
    },
  },
  professionalNumber: {
    label: "Numero Professionale",
    placeholder: "1234567",
    errors: {
      required: "Si prega di inserire un numero professionale",
      maxLength: "L'input supera il limite di caratteri",
    },
  },
  addressSearch: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  businessSearchField: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  checkbox: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  combobox: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  datePicker: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  dateRange: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  dateTime: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  emailField: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  fileInput: {
    errors: {
      required: "Selezionare un file",
    },
  },
  number: {
    errors: {
      required: "Si prega di inserire un numero",
      minValue: "Si prega di inserire un valore superiore al minimo",
      maxValue: "Si prega di inserire un valore inferiore al massimo",
    },
  },
  passwordField: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  rangeSlider: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  select: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  telephoneField: {
    errors: {
      required: "Inserire solo numeri",
      invalidTelephone: "Inserire un numero di telefono valido",
      invalidFormat: "Formato numero non valido",
    },
  },
  text: {
    errors: {
      required: "Utilizzare solo lettere (A-Z), numeri (0-9) e nessun simbolo",
      maxLength: "L'input supera il limite di caratteri",
      minLength: "L'input deve contenere almeno 2 caratteri",
    },
  },
  textarea: {
    characters: "caratteri",
  },
  time: {
    errors: {
      required: "Questo campo è obbligatorio",
    },
  },
  form: {
    errors: {
      generic:
        "Abbiamo riscontrato un errore nell'invio del modulo. Si prega di riprovare.",
      reportAnIssue: "Si prega di segnalare un problema.",
      configuration: "Errore di Configurazione",
      noFormQuestionsAvailable: "Nessuna domanda del modulo disponibile.",
      formComponentLoad:
        "Il componente del modulo non è stato caricato a causa di un campo non supportato.",
      code: "Codice",
      type: "Tipo",
      missingRequiredFields:
        "Questo modulo non contiene i campi obbligatori (Email e/o Consenso). Contattare un amministratore per correggere la configurazione del modulo.",
    },
  },
};
const ROLES = [
  { value: "Academic", label: "Accademico", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Benessere Animale - Altro",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Benessere Animale - Personale al Dettaglio",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Benessere Animale - Veterinario",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Benessere Animale - Infermiere Veterinario",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Benessere Animale - Volontario",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Estensione Bovini da Carne / Allevamento da Ingrasso",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Produttore di Carne Bovina",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Allevatore", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Amministratore Aziendale / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Titolare / Partner Aziendale",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Nutrizionista Consulente",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Dipendente Aziendale (non Veterinario)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Produttore Lattiero-Caseario",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributore", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Rappresentante Distributore, sul Campo",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Rappresentante Distributore, Interno",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Istituzione Educativa - Studente di Scuola Superiore",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Istituzione Educativa - Studente TAFE",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Istituzione Educativa - Studente Universitario",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Toelettatore", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Direttore Medico / Clinico",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrizione / Vendita Mangimi",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Professionista della Nutrizione",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutrizionista", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Responsabile Ufficio / Studio",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "Rivenditore OTC", id: "otc_retailer" },
  { value: "Pharmacist", label: "Farmacista", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Farmacia - Personale",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Allevatore di Suini", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Allevatore di Pollame",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Titolare di Studio (non Veterinario)",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist / Servizio Clienti",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Negozio Rivenditore - Personale",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Produttore - Misto/Altro",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Rivenditore",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Allevatore di pecore",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Studente RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinario/a",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Addestratore", id: "trainer" },
  { value: "Veterinarian", label: "Veterinario", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinario, Titolare di Studio",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Assistente Veterinario",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Infermiere Veterinario",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Studio Veterinario - Altro",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Studio Veterinario - Veterinario",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Studio Veterinario - Infermiere Veterinario",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinario Specialista",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Studente di Veterinaria",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Chirurgo Veterinario",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Tecnico Veterinario",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Grossista", id: "wholesaler" },
];
const SALUTATIONS = [
  {
    label: "Dott.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "M.",
    value: "M.",
    id: "m",
  },
  {
    label: "Signorina",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Sig.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Sig.ra",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Sig.ra",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professore",
    value: "Professor",
    id: "professor",
  },
];
export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
